import React from 'react';
import { Metafield } from '../Metafield';
import { useProduct } from '../../hooks/useProduct/useProduct';
/**
 * The `ProductMetafield` component renders a
 * [`Metafield`](/api/hydrogen/components/primitive/metafield) component with the product metafield.
 * It must be a descendent of a `ProductProvider` component.
 */
export function ProductMetafield(props) {
    const product = useProduct();
    if (product == null) {
        throw new Error('Expected a ProductProvider context, but none was found');
    }
    if (product.metafields == null) {
        console.warn('No metafields available for product');
        return null;
    }
    const { namespace, keyName, ...passthroughProps } = props;
    const field = product.metafields.find((metafield) => metafield.namespace === namespace && metafield.key === keyName);
    return field ? React.createElement(Metafield, { metafield: field, ...passthroughProps }) : null;
}
